export default __webpack_public_path__ + "static/FS2S-InHub-106-64d123220dc8150de0b9fa9c1a214d28.jpg";